import { Box, Divider, Skeleton, Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { UsageCard } from "./UsageCard"

const useStyles = makeStyles()(() => ({
    legendColumn: {
        flex: "1 1 20rem",
    },
    divider: {
        margin: "1.5rem 0",
    },
    sectionRow: {
        padding: "1rem .25rem",
    },
    sectionBar: {
        flex: "0 0 45%",
        maxWidth: "28rem",
    },
}))

export function SummarySkeleton() {
    const { classes } = useStyles()

    return (
        <UsageCard>
            <Stack direction="row" flexWrap="wrap" alignItems="center" gap="2.5rem">
                <Skeleton variant="circular" width="12rem" height="12rem" />
                <Stack gap=".75rem" className={classes.legendColumn}>
                    {Array.from({ length: 6 }).map((_, index) => (
                        <Skeleton key={index} variant="text" width="100%" height="1.5rem" />
                    ))}
                </Stack>
            </Stack>
            <Divider className={classes.divider} />
            <Stack direction="row" gap="4rem" marginTop="1.5rem">
                <Skeleton variant="rounded" width="6rem" height="3rem" />
                <Skeleton variant="rounded" width="6rem" height="3rem" />
            </Stack>
        </UsageCard>
    )
}

export function SectionsSkeleton() {
    const { classes } = useStyles()

    return (
        <UsageCard>
            <Skeleton variant="text" width="10rem" height="2rem" />
            {Array.from({ length: 5 }).map((_, index) => (
                <Stack key={index} direction="row" alignItems="center" gap="1.5rem" className={classes.sectionRow}>
                    <Skeleton variant="text" width="8rem" height="1.5rem" />
                    <Box className={classes.sectionBar}>
                        <Skeleton variant="rounded" width="100%" height=".75rem" />
                    </Box>
                    <Skeleton variant="circular" width="1rem" height="1rem" />
                </Stack>
            ))}
        </UsageCard>
    )
}
